import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';

import * as selector from '../../selectors';

const mapStateToProps = state => {
	return {
		settings: selector.getSettings(state),
	};
};

@connect(mapStateToProps)
export default class extends Component {
	static propTypes = {
		settings: PropTypes.object,
	}

	render() {
		const {
			settings: {vk, tg, facebook, instagram, review_on, pass_on},
		} = this.props;

		const links = [
			{type: 'vk', url: vk},
			{type: 'tg', url: tg},
			{type: 'facebook', url: facebook},
			{type: 'instagram', url: instagram},
		];

		return (
			<div className="social">
				{links.map(link => link.url && (
					<a key={link.type} className={link.type} href={link.url} target="_blank" />
				))}
				{!!Number(pass_on) && (
					<Link to="/card" className="wallet" />
				)}
				{!!Number(review_on) && (
					<Link to="/review" className="leave-review">Оставить отзыв</Link>
				)}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/widgets/Social.js